import React from 'react';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typewriter from 'typewriter-effect';
import pdf from '../img/Ali_Haydar(Resume).pdf'

function HomePage() {
    return (
        <div className="HomePage">
            <header className="hero">
                <h1 className="hero-text">
                    Hi, I am
                    <span><Typewriter
                        options={{
                            strings: ['Ali Haydar', 'Full-Stack Web Developer'],
                            autoStart: true,
                            loop: true,
                        }}
                    /></span>
                </h1>
                <p className="h-sub-text">
                    I try to develop the front end of a web application using React.js
                    and the back-end using Node.js with comfortable. I am always ready to learn any new technology. I am
                    excited to be joining your company to enhance your company name and reputation day by day.
                </p>
                <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                    <button className="btn"><a href={pdf} style={{ textDecoration: 'none', color: 'white' }} download='Ali_Haydar(Resume).pdf' >Download Resume</a></button>
                </div>
                <div className="icons">
                    <a className="icon-holder" href='https://www.linkedin.com/in/alihaydararman/'>
                        <FontAwesomeIcon icon={faLinkedin} className="icon fb" />
                    </a>
                    <a className="icon-holder" href='https://twitter.com/alihaydararman'>
                        <FontAwesomeIcon icon={faTwitter} className="icon fb" />
                    </a>
                    <a className="icon-holder" href='https://github.com/alihaydararman'>
                        <FontAwesomeIcon icon={faGithub} className="icon fb" />
                    </a>
                    <a className="icon-holder" href='https://www.facebook.com/alihaydararman/'>
                        <FontAwesomeIcon icon={faFacebook} className="icon fb" />
                    </a>
                </div>
            </header>
        </div>
    )
}

export default HomePage;
